import * as React from 'react';
import * as main from "../../main.module.scss";
import * as message from "./style.module.scss";
export const Message = () => {
  return (
    <section className={message.message}>
      <div className="container">
        <div className={message.wrap}>
          <div className={message.authorWrap}>
            <img src="https://fs.advance.ru/landing-pages/webinar/nauchite_detey_uchitsya/_dontspeak/AZ-big.png" alt={""}/>
            <p className={message.author}><span>Александр Згода</span>Генеральный и академический директор Advance</p>
          </div>
          <div className={message.textWrap}>
            <h2 className={main.title}>От автора:</h2>
            <blockquote className={message.quote}>
              <p>Не секрет, что основной вид деятельности ребенка - это обучение, так как это трамплин для всей его дальнейшей жизни! Это своеобразная работа ребенка на первую треть жизни, результатом которой будет качество жизни следующие две трети. Учимся мы всегда для того, чтобы выполнять последующую работу быстро и качественно, а вот как выполнять нашу первую и самую важную работу - "обучаться", нас никто и не научил. К сожалению, ни в школе, ни в ВУЗе нас в действительности не учили, как правильно работать с информацией и эффективно учиться самостоятельно, выбирать нужную литературу, искать, запоминать, сохранять и повторять информацию, быстро читать, готовиться  к экзаменам, грамотно конспектировать, писать рефераты, отрабатывать навыки, простраивать план своего обучения и т.д</p>
              <p><strong>Устранению этого пробела в обучении наших детей и будет посвящен наш семинар, приходите.</strong></p>
            </blockquote>
          </div>
        </div>
      </div>
    </section>
  );
};
